import { ref, watch } from "@vue/composition-api";

export const useElementSize = <T extends Element>() => {
  const elementRef = ref<T>();

  const size = ref({
    width: 0,
    height: 0
  });

  const resizeObserver = ref<ResizeObserver>();

  watch(elementRef, () => {
    if (resizeObserver.value) {
      resizeObserver.value.disconnect();
    }

    if (!elementRef.value) return;

    resizeObserver.value = new ResizeObserver(entries => {
      entries.forEach(entry => {
        size.value = {
          width: entry.target.clientWidth,
          height: entry.target.clientHeight
        };
      });
    });

    resizeObserver.value.observe(elementRef.value);
  });

  return [elementRef, size] as const;
};
